import React from 'react';

import {ExportType, LegacyRunQueryState} from 'insights/warehouse/AnalyticsWarehouseTypes';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';
import Option from 'ui-library/menus/Option';

export type ExportBlockFn = (exportType: ExportType) => void;

interface Actions {
  exportBlock: ExportBlockFn;
}

interface Props {
  actions: Actions;
  runQueryState: LegacyRunQueryState;
  showRawOutput: boolean;
}

export default function getDownloadAsCSVOption(props: Props): JSX.Element {
  const {exportType, optionText} = props.showRawOutput
    ? {exportType: ExportType.RAW_OUTPUT_CSV, optionText: 'Download raw output as CSV'}
    : {exportType: ExportType.RESOLVED_OUTPUT_CSV, optionText: 'Download as CSV'};

  function handleSelect(): void {
    props.actions.exportBlock(exportType);
  }

  return (
    <Option
      icon="download"
      isDisabled={props.runQueryState.status !== AsyncStatus.SUCCESS}
      onSelect={handleSelect}
      dataTestAttrs={{
        component: 'BaseBlockOverflowDropdown',
        element: 'menuOption',
        key: 'downloadAsCSV',
      }}
    >
      {optionText}
    </Option>
  );
}
